import { observer } from "mobx-react-lite";
import { formatNumber } from "../../utils/utils";
import infoStyles from '../Info.module.css';

function TenantInMarketInfo({ description, landAreaMin, landAreaMax, buildingAreaMin, buildingAreaMax, className, onClick }: ITenantInMarketInfoProps) {
    return (
        <div className={[infoStyles.container, className].join(" ")} onClick={onClick}>
            <div className={infoStyles.title}>{description}</div>

            <div className={infoStyles.description}>
                {[
                    !!landAreaMin && !!landAreaMax && `${formatNumber(landAreaMin)} - ${formatNumber(landAreaMax)} Acres`,
                    !!buildingAreaMin && !!buildingAreaMax && `${formatNumber(buildingAreaMin)} - ${formatNumber(buildingAreaMax)} Sq-Ft`,
                ].filter(d => d).join(" - ")}
            </div>
        </div>
    );
}

export interface ITenantInMarketInfoProps {
    description: string | null;
    landAreaMin: number;
    landAreaMax: number;
    buildingAreaMin: number;
    buildingAreaMax: number;
    className?: string;
    onClick?: () => void;
}

export default observer(TenantInMarketInfo);